import { useId } from 'react';
import type { CSSProperties } from 'react';
import { getDotPattern } from '../../core';
import { selectViewport, useMindmapStore } from '../../store';
import { classNames } from '../../utils';

/** React Flow v11 dot colour. */
const DEFAULT_DOT_COLOR = '#91919a';
const DEFAULT_GAP = 20;
const DEFAULT_SIZE = 1;

export type BackgroundProps = {
  /** Only `dots` is built; the app uses nothing else (D-016). */
  variant?: 'dots';
  gap?: number;
  size?: number;
  color?: string;
  className?: string;
  style?: CSSProperties;
};

/** The dotted canvas background (v11 `<Background variant="dots">`), drawn behind the nodes and moving with the view. */
export const Background = ({ gap = DEFAULT_GAP, size = DEFAULT_SIZE, color = DEFAULT_DOT_COLOR, className, style }: BackgroundProps) => {
  const viewport = useMindmapStore(selectViewport);
  const patternId = `cm-background-${useId()}`;
  const { tileSize, offsetX, offsetY, radius } = getDotPattern(viewport, gap, size);
  return (
    <svg className={classNames('cm-background', className)} style={style}>
      <pattern
        id={patternId}
        x={offsetX}
        y={offsetY}
        width={tileSize}
        height={tileSize}
        patternUnits="userSpaceOnUse"
        patternTransform={`translate(-${radius},-${radius})`}
      >
        <circle cx={radius} cy={radius} r={radius} fill={color} />
      </pattern>
      <rect x="0" y="0" width="100%" height="100%" fill={`url(#${patternId})`} />
    </svg>
  );
};
